<div nz-row>
  <div nz-col nzSpan="24" style="margin-bottom: 1rem;" class="no-form">
    <h1 i18n="Identity.EditCredentials.Title|title for edit credential page@@Identity.EditCredentials.Title">Gestione credenziali</h1>
  </div>
</div>

<!-- <div nz-row [nzGutter]="[32, 32]">
    <div nz-col class="data-column" nzSpan="12">
      <h3 class="data-section-title">Dati residenza</h3>
      <div class="data-box">
        <span class="data-type">Stato e Provincia</span>
        <span class="data-value">Italia - Napoli</span>
      </div> -->
<nz-spin i18n-nzTip="Auth.Generic.SpinnerText|text in spinner@@Auth.Generic.SpinnerText"
    nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
    <div nz-row>
      <div nz-col class="data-column no-form" nzSpan="24">
        <div class="data-box">
          <span class="data-type">Livello SPID</span>
          <span class="data-value">{{getDisplaySpidLevel()}}</span>
        </div>
      </div>
      <div nz-col class="data-column no-form" nzSpan="24">
        <div class="data-box">
          <span class="data-type">Stato</span>
          <span class="data-value">{{identity.status | getIdentityDisplayStatusPipe}}</span>
        </div>
      </div>
      <div nz-col class="data-column no-form" nzSpan="24">
        <div class="data-box">
          <span class="data-type">Valido fino al</span>
          <span class="data-value">{{identity.expire_date | date:'dd/MM/YYYY'}}</span>
        </div>
      </div>
      <div nz-col class="data-column no-form" nzSpan="24">
        <div class="data-box">
          <span class="data-type">Scadenza Password</span>
          <span class="data-value">{{identity.password_expire_date | date:'dd/MM/YYYY'}}</span>
        </div>
      </div>
      <div nz-col class="data-column no-form" nzSpan="24">
        <div class="data-box">
          <span class="data-type">Password</span>
          <span class="data-value">******* <a nz-button nzType="link" class="inner-cta" (click)="onChangePassword()">Modifica</a></span>
        </div>
      </div>
      <div nz-col class="data-column no-form" nzSpan="24">
        <div class="data-box" *ngIf="+identity.level === 2 && showAuthenticationWithApp">
          <span class="data-type" i18n="@@EditCredentials.OnChangeAuthenticationWithApp.Label">Autenticazione tramite app</span>
          <form nz-form class="data-value">
            <nz-form-item>
              <nz-form-control>
                <nz-switch [(ngModel)]="identity.otp_delivery_methods.APP.enabled" name="authenticationWithApp" (ngModelChange)="onChangeAuthenticationWithApp($event)"></nz-switch>
              </nz-form-control>
            </nz-form-item >
          </form>
        </div>
      </div>
    </div>
</nz-spin>

<app-modify-password [events]="onModifyPasswrdEventSubject.asObservable()"></app-modify-password>

<nz-modal
  [(nzVisible)]="isQrCodeAssociationComponentVisible"
  [nzTitle]="'Associa il tuo telefono'"
  [nzClosable]="false"
  [nzContent]="qrCodeTmpl"
  [nzFooter]="qrCodeButtonTmpl"
  nzClassName="qrCodeAssociationModal"
>
  <ng-template #qrCodeTmpl>
    <app-qr-code-association
      [description]="descriptionTmpl"
      (onSyncronizeWithApp)="updateOtpDeliveryMethod($event)"
    >
      <ng-template #descriptionTmpl>
        <div nz-row [nzGutter]="16">
          <div nz-col>
            <span nz-icon nzType="appstore" nzTheme="outline"></span>
          </div>
          <div nz-col nzFlex="1">
            <p i18n="@@EditCredentials.QrCodeAssociation.Description.Paragraph.First" class="mb-16">
              Vai sullo Store del tuo telefono (IPhone o Android) e scarica l'app <b>"TSID abilitato SPID"</b>
            </p>
          </div>
        </div>
        <div nz-row nzGutter="16">
          <div nz-col>
            <span nz-icon nzType="barcode" nzTheme="outline"></span>
          </div>
          <div nz-col nzFlex="1">
            <p i18n="@@EditCredentials.QrCodeAssociation.Description.Paragraph.Second" class="mb-16">
              Segui le indicazioni sul telefono e quando rischiesto, scansiona il QR Code:
            </p>
          </div>
        </div>
      </ng-template>
    </app-qr-code-association>
  </ng-template>
  <ng-template #qrCodeButtonTmpl>
    <button nz-button (click)="onEndQrCodeAssociation()"> Chiudi </button>
  </ng-template>
</nz-modal>

